import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

function Summary({ basic }) {
  const { live = 0, down = 0 } = basic;

  return (
    <>
      <Header>
        <Logo src={require('./images/kop.png')} />
        <TotalContainer>
          集群总数
          <TotalNum>{live + down}</TotalNum>
        </TotalContainer>
      </Header>
      <Body>
        <Row>
          <Col>
            <Icon src={require('./images/check-circle.png')} />
            <Label>在线</Label>
            {live}
          </Col>
          <Col>
            {down > 0 && <Icon src={require('./images/x-circle.png')} />}
            <Label>离线</Label>
            {down}
          </Col>
        </Row>
        <BarContainer>
          <Bar flex={live} />
          <Bar error flex={down} />
        </BarContainer>
      </Body>
    </>
  );
}

export default connect((state) => ({
  basic: state.kopCluster.basic || {},
}))(Summary);

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.img`
  width: auto;
  height: 24px;
  margin-top: -2px;
`;

const TotalContainer = styled.div`
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--td-font-gray-2);
`;

const TotalNum = styled.div`
  font-weight: 500;
  font-size: 28px;
  line-height: 40px;
  color: var(--td-font-gray-1);
  margin-left: 8px;
`;

const Body = styled.div`
  background: rgba(125, 133, 146, 0.06);
  border-radius: 8px;
  padding: 10px;
  margin-top: 8px;
  margin-bottom: 20px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Col = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: var(--td-font-gray-1);
  display: flex;
  font-weight: bold;
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

const Label = styled.div`
  margin: 0 8px 0 4px;
  font-weight: 400;
`;

const BarContainer = styled.div`
  border-radius: 2px;
  overflow: hidden;
  height: 4px;
  display: flex;
  margin-top: 8px;
`;

const Bar = styled.div`
  border-radius: 2px;
  background: #10b880;
  position: relative;
  z-index: 2;
  flex: ${(props) => props.flex || 0};
  ${(props) =>
    props.error &&
    `
    background: #EE4444;
    margin-left: -3px;
    z-index: 1;
  `}
`;
